export default [
  {
    path: '/label/profile',
    name: 'Label Profile',
    component: () =>
      import(/* webpackChunkName: 'profile-label' */ './views/Index.vue')
  },
  {
    path: '/label/help-desk',
    name: 'Label Help Desk',
    component: () =>
      import(/* webpackChunkName: 'label-help-desk' */ './views/HelpDesk.vue')
  }
]
